import { createUppyPlugin } from '@teamango/core';

export const UppyPlugin = createUppyPlugin({
  endpoint: import.meta.env.VITE_TEAMANGO_API_URL,
  cookiesRule: 'include',
});
